// extracted by mini-css-extract-plugin
module.exports = {"menu":"editor_menu__1o_US","active":"editor_active__2mpVG","is-active":"editor_is-active__3406p"};